import { useContext } from "react";
import { FacebookOAuthContext } from "../context";

/**
 * Hook that provides access to the Facebook OAuth context.
 *
 * @returns {Object} The context provided by FacebookOAuthProvider.
 * @throws {Error} If called outside of a FacebookOAuthProvider.
 */
export function useFacebookOAuth() {
	const context = useContext(FacebookOAuthContext);
	if (!context) {
		throw new Error(
			"Facebook OAuth components must be used within FacebookOAuthProvider"
		);
	}
	return context;
}
